"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TooltipContainer_1 = __importDefault(require("./TooltipContainer"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var SHARE_BUTTON_ENABLED_TOOLTIP = {
    label: "share page",
    message: "Click here to edit this page's share settings, change its preview image, and set it live.",
};
var shareButton = function (_a) {
    var onClick = _a.onClick, disableTooltip = _a.disableTooltip, buttonProps = __rest(_a, ["onClick", "disableTooltip"]);
    return (react_1.default.createElement(TooltipContainer_1.default, { tooltip: SHARE_BUTTON_ENABLED_TOOLTIP, disableTooltip: disableTooltip },
        react_1.default.createElement(kaleidoscope_1.Button, __assign({ className: "button--share", type: kaleidoscope_1.ButtonType.Primary, size: kaleidoscope_1.ButtonSize.Medium, onClick: onClick }, buttonProps), "Share")));
};
exports.default = shareButton;
